<div class="field col-12">
    <label>{{pergunta.detalhesTitulo}}</label>

    <input type="text" pInputText [(ngModel)]="pergunta.resposta" [disabled]="!habilitado"
        (ngModelChange)="respostaAlterada()" />
</div>